<template>
  <div class="transaction-table">
    <table class="table">
      <thead>
        <tr>
          <th class="is-hidden-mobile">{{ $t("table.date") }}</th>
          <th>{{ $t("table.account") }}</th>
          <th class="is-hidden-mobile">{{ $t("table.hash") }}</th>
          <th>{{ $t("table.amount") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="transaction in transactions" :key="transaction.hash">
          <!-- date -->
          <td class="date is-hidden-mobile">
            {{ $utils.formatTimestamp(transaction.timestamp) }}
          </td>
          <!-- account -->
          <td class="account">
            <a class="has-text-dark" v-bind:href="'#/account/'+ transaction.from">
              {{ transaction.from }}
            </a>
          </td>
          <!-- hash -->
          <td class="hash is-hidden-mobile">
            <a class="has-text-dark" v-bind:href="'#/tx/'+ $utils.formatHash(transaction.hash)">
              {{ $utils.formatHash(transaction.hash) }}
            </a>
          </td>
          <!-- amount -->
          <td class="amount" :class="amountType()">
            {{ $utils.formatAmount(transaction.value) }} <!-- {{ coinName }} -->
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'transaction-table',
    computed: {
      coinName () {
        return this.$COINNAME
      },
      transactions () {
        return this.$store.state.chainStatus.latestTransactions.slice(0, 10)
      }
    },
    methods: {
      amountType () {
        return 'has-text-dark'
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/TransactionTable.vue